var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExercise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#1CADF1",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36 17.6249C25.8675 17.6249 17.625 25.8674 17.625 35.9999C17.625 37.7954 17.8893 39.5804 18.4108 41.3077C18.6208 42.0024 18.227 42.7339 17.534 42.9439C16.8322 43.1522 16.106 42.7567 15.8978 42.0654C15.3028 40.0932 15 38.0527 15 35.9999C15 24.4202 24.4203 14.9999 36 14.9999C40.347 14.9999 44.4613 16.3369 47.9105 18.7344L51.26 15.3849C51.6345 15.0087 52.1998 14.8949 52.6898 15.0997C53.1798 15.3027 53.5 15.7822 53.5 16.3124V24.1874C53.5 24.9119 52.912 25.4999 52.1875 25.4999H44.3125C43.7805 25.4999 43.3027 25.1797 43.0998 24.6897C42.8985 24.1997 43.0088 23.6344 43.385 23.2599L46.031 20.6122C43.0963 18.6872 39.6383 17.6249 36 17.6249ZM54.466 29.056C55.1643 28.8477 55.894 29.2415 56.1023 29.9345C56.6973 31.9067 57 33.9472 57 36C57 47.5797 47.5798 57 36 57C31.653 57 27.5387 55.663 24.0895 53.2655L20.74 56.615C20.355 57 19.7863 57.098 19.3103 56.9002C18.8203 56.6972 18.5 56.2177 18.5 55.6875V47.8125C18.5 47.088 19.088 46.5 19.8125 46.5H27.6875C28.2195 46.5 28.6973 46.8202 28.9003 47.3102C29.1015 47.8002 28.9913 48.3655 28.615 48.74L25.969 51.3877C28.9038 53.3127 32.3618 54.375 36 54.375C46.1325 54.375 54.375 46.1325 54.375 36C54.375 34.2045 54.1108 32.4195 53.5893 30.6922C53.3793 29.9975 53.773 29.266 54.466 29.056Z",
    fill: "#1CADF1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6251 30.4533C40.6485 29.5161 43.3223 29 46.1538 29H47V42.1681H46.1538C43.5565 42.1681 41.1294 42.6298 39.3195 43.4681C38.1265 44.0206 37.3196 44.6854 37 45.359V31.4087C37.461 31.0612 38.0042 30.7408 38.6251 30.4533ZM35 31.4087C34.539 31.0612 33.9958 30.7408 33.3749 30.4533C31.3515 29.5161 28.6777 29 25.8462 29H25V42.1681H25.8462C28.4434 42.1681 30.8706 42.6298 32.6805 43.4681C33.8735 44.0206 34.6804 44.6854 35 45.359V31.4087Z",
    fill: "#1CADF1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise);
export default __webpack_public_path__ + "static/media/Exercise.5acd41d4cf3c6418619f4bb365d0394e.svg";
export { ForwardRef as ReactComponent };